<!-- #63 -->
<template>
  <v-col class="mx-3">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Search Token
      </div>
      <v-spacer> </v-spacer>
    </div>

    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-text>
        <v-form ref="form" @submit.prevent="save" type="submit">
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-text-field
                outlined
                v-model="tokenNumber"
                label="Token Number"
                :rules="[
                  (v) => (v && !!v.trim()) || 'Token Number is required.',
                ]"
                class="required"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-btn color="primary" :loading="loader" @click="save" class="mt-8"
              >Search</v-btn
            >
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>

    <v-card v-if="gettokenDetails.token_number">
      <v-card-title class="card-title pb-2 pl-3">Token Details </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-0">
        <v-row class="pl-0">
          <v-col cols="12">
            <v-col cols="12" class="pl-0">
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  Token Number:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.token_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Warehouse:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.wms_warehouse_code }}</b>
                </div>
              </div>
              <div
                class="col-md-6 d-flex p-0 m-0"
                v-if="gettokenDetails.dock_number"
              >
                <div class="col-md-4 p-0 text-medium-emphasis">
                  Dock Number Allocated:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.dock_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Delivery Date:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.delivery_date }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Purpose:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.purpose }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Security Gaurd Name:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.security_guard_name }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Security Gaurd Phone:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.security_guard_phone }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Supplier Name:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.supplier_name }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Is invoice number available ?:</div>
                <div class="text-left col-md-7 p-0">
                  <b>
                    {{
                      gettokenDetails.invoice_number_available == 1
                        ? "Yes"
                        : "No"
                    }}</b
                  >
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Invoice Number:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.invoice_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Invoice Quantity:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.invoice_quantity }}</b>
                </div>
              </div>

              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Reason for no invoice:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.reason_no_invoice_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Type of vehicle:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.vehicle_type }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Vehicle Number:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.vehicle_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Vehicle Temprature:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.vehicle_temperature }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Container Number:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.container_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Seal Number:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.seal_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Driver Name:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.driver_name }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">
                  Additional name along with Driver:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.additional_name }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Driver Number:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.driver_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Driver licence Number:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.driver_license_number }}</b>
                </div>
              </div>

              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Event Status:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.latest_event_status }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0">Report in time:</div>
                <div class="text-left col-md-7 p-0">
                  <b>{{
                    gettokenDetails.reported_in_datetime
                      | localMomentNew
                      | moment("DD MMM, YYYY hh:mm A")
                  }}</b>
                </div>
              </div>
            </v-col>
          </v-col></v-row
        >
        <v-divider></v-divider>
        <v-row class="pl-0" v-if="gettokenDetails.storer">
          <v-col cols="12">
            <v-col cols="12" class="pl-0">
              <div><b>DOCK IN</b></div>

              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  Storer Name:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.storer }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  Unloading Type:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.unloading_type }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">Comments:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.dock_in_remark }}</b>
                </div>
              </div>
            </v-col>
          </v-col>
        </v-row>

        <v-divider></v-divider>
        <v-row class="pl-0" v-if="gettokenDetails.asn_shipment_number">
          <v-col cols="12">
            <v-col cols="12" class="pl-0">
              <div><b>DOCK OUT</b></div>

              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">ASN Number:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.asn_shipment_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  Shipment Number:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.shipment_number }}</b>
                </div>
              </div>

              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  LPO/Reference Number:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.lpo_number }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  Projected Quantity:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.projected_quantity }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  Received/Loaded Quantity:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.received_quantity }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  Pallet Quantity:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.pallet_quantity }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  RTO Employee Count:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.rto_employee_count }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  TC Employee Count:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.tc_employee_count }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  WHA Employee Count:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.wha_employee_count }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  FLO Employee Count:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.flo_employee_count }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">
                  Outsourced Employee Count:
                </div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.osl_employee_count }}</b>
                </div>
              </div>
              <div class="col-md-6 d-flex p-0 m-0">
                <div class="col-md-4 p-0 text-medium-emphasis">Comments:</div>
                <div class="text-left col-md-7 p-0">
                  <b> {{ gettokenDetails.dock_out_comment }}</b>
                </div>
              </div>
            </v-col>
          </v-col>
        </v-row>
        <v-divider></v-divider>

        <v-col class="d-flex pl-0">
          <barcode
            tag="img"
            :value="gettokenDetails.token_number"
            :options="{
              displayValue: false,
              lineColor: '#2B2B2C',
              height: 100,
            }"
          >
          </barcode>
        </v-col>

        <v-col class="d-flex">
          <v-btn
            color="primary"
            @click="print"
            v-if="checkPermission('app_pas:download_gate_token')"
            class="mr-2"
            >Print</v-btn
          >
          <v-btn
            color="primary"
            :loading="loader"
            @click="driver"
            v-if="
              gettokenDetails.is_signature_done !== 1 &&
              checkPermission('app_pas:gate_token_driver_declaration') &&
              gettokenDetails.active !== 3
            "
            >Driver Declaration</v-btn
          >
          <v-col v-else style="color: red">
            <b v-if="gettokenDetails.active == 3">
              Unable to do Driver Declaration because token status is
              {{ gettokenDetails.latest_event_status }}
            </b>
            <b v-else>Driver Declaration has been already signed </b>
          </v-col>
        </v-col>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { axios } from "@/plugins/http-request.js";
import VueBarcode from "vue-barcode";

import { mapActions } from "vuex";

export default {
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    loader: false,
    gettokenDetails: {},
    tokenNumber: "",
  }),

  async created() {
    if (this.$route.query.token) {
      this.tokenNumber = this.$route.query.token;
      this.loader = true;

      axios
        .get(`/api/pas/search_token?token_number=${this.tokenNumber}`)
        .then((res) => {
          this.loader = false;

          if (res.data.data.records.length == 0) {
            this.loader = false;
            this.snackBar({
              color: "error",
              message: "No Record Found",
            });

            this.gettokenDetails = {};
          } else {
            this.gettokenDetails = res.data.data.records[0];
          }
        });
    }
  },

  methods: {
    ...mapActions(["snackBar"]),
    print() {
      axios
        .get(`/api/gate_token/download/${this.gettokenDetails.token_number}`, {
          responseType: "blob",
        })
        .then((res) => {
          this.fileDownload(res, "pdf");
        });
    },
    driver() {
      this.$router.push({
        name: "PasDriver",
        params: {
          id: this.gettokenDetails.token_number,
          name: this.gettokenDetails.driver_name,
          number: this.gettokenDetails.driver_number,
          token_number: this.gettokenDetails.token_number,
        },
      });
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.loader = true;

      axios
        .get(`/api/pas/search_token?token_number=${this.tokenNumber}`)
        .then((res) => {
          this.loader = false;

          if (res.data.data.records.length == 0) {
            this.loader = false;
            this.snackBar({
              color: "error",
              message: "No Record Found",
            });

            this.gettokenDetails = {};
          } else {
            this.gettokenDetails = res.data.data.records[0];
          }
        });
    },
  },
};
</script>
<style scoped>
.p-0 {
  padding: 0px !important;
}
</style>
